import { createAsyncThunk } from '@reduxjs/toolkit';

import { adaptDeliverySettingsToStore } from 'src/adapters/serviceToStore/adaptDeliverySettingsToStore';
import type { ReduxApplicationState } from 'src/redux/types';
import { fetchDeliveryOptions } from 'src/services/delivery-settings/fetchDeliveryOptions';
import type { Price } from 'src/types/price';
import type { DeliveryZone } from './types';

interface RequestDeliveryZoneOptions {
  productCode: number;
  productPrice: Price;
}

export const requestDeliveryZoneOptions = createAsyncThunk<
  DeliveryZone[],
  RequestDeliveryZoneOptions,
  { rejectValue: Error }
>(
  'delivery/requestDeliveryZoneOptions',
  async ({ productCode, productPrice }, { getState, rejectWithValue }) => {
    try {
      const userCurrencyCode = (getState() as ReduxApplicationState).user.currencyCode;
      const deliveryZoneOptions = await fetchDeliveryOptions(productCode, productPrice);

      return adaptDeliverySettingsToStore(deliveryZoneOptions, userCurrencyCode);
    } catch (error) {
      const serializableError =
        error instanceof Error
          ? { message: error.message, name: error.name, stack: error.stack }
          : { message: 'Unknown error fetching delivery options', name: 'Error' };

      return rejectWithValue(serializableError);
    }
  },
);
